import { getToken } from "@/services/token.service";

export default {
  token: getToken,
  user: null
};
